import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import ChatCreateResponseDto from "../../dto/ChatCreateResponseDto";
import baseUrl from "../../api/baseUrl";
import {RootState} from "../index";

interface Chat {
    id: string;
    messages: string[];
}

interface Message {
    content: string;
}

export const chatApi = createApi({
    reducerPath: 'chatApi',
    tagTypes: ['Chats'],
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/api/chat`,
        prepareHeaders: (headers, {getState}) => {
            const token = (getState() as RootState).auth.token;

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        createChat: builder.mutation<ChatCreateResponseDto, null>({
            query: () => ({
                url: '/create',
                method: 'POST',
            }),
        })
    }),
});

export const {useCreateChatMutation} = chatApi;
